export enum DocumentType{

    DNI = 'DNI',

    NIE = 'NIE'
}